import React, { memo } from "react";
import { Card } from 'react-bootstrap';
import PracticeHeader from "components/PracticeMaterial/New/PracticePageHeaderComponents/PracticeHeader";
import QuestionTagSelect from "components/PracticeMaterial/New/PracticePageHeaderComponents/QuestionTagSelect";
import PracticeClockMain from "components/PracticeMaterial/New/PracticePageHeaderComponents/PracticeClockMain";
import QuestionStrategyVideo from "components/PracticeMaterial/New/PracticePageHeaderComponents/QuestionStrategyVideo";

const PracticePageHeader = memo(function PracticePageHeader({
	questionData, isAttempted, TAGS, toggle, isOpen, changeHandler,
	time, subcategoryId, title, strategyVideo, isLoading, retryError = false,videoURL
}) {

	const formattedTime = React.useMemo(() => {
		return {
			hours: Math.floor(time / 3600),
			minutes: Math.floor((time % 3600) / 60),
			seconds: Math.floor(time % 60),
		};
	}, [time]);

	return (
		<Card className="p-3">
			<Card.Header className={"p-0 d-flex gap-3"}>
				<div className="dash-col-1 practice-page-header">
					<PracticeHeader
						questionData={questionData}
						isAttempted={isAttempted}
					/>
					<div  style={{width:"max-content"}} 
					className={`tag-time-container ${retryError ? "disabled" : ""}`}>
						<div id="practice-question-tag">
						<QuestionTagSelect
							TAGS={TAGS}
							questionData={questionData}
							toggle={toggle}
							isOpen={isOpen}
							changeHandler={changeHandler}
							isLoading={isLoading}
						/>
							</div>
                     <div id="practice-time-spent">
						<PracticeClockMain
						// time={time}
						hours={formattedTime.hours}
						minutes={formattedTime.minutes}
						seconds={formattedTime.seconds}
						/>
						</div>
					</div>
				</div>
				{videoURL && (
					<QuestionStrategyVideo
						subcategoryId={subcategoryId}
						strategyVideo={strategyVideo}
					/>
				)}  

				<div className={`dash-col-3 h-100 ${!videoURL ? 'flex-grow-1' : ''}`}>
					<Card.Body className="p-0 h-100">
						<p className="gray-text h-100">{title}</p>
					</Card.Body>
				</div>
			</Card.Header>
		</Card>
	);
});
export default PracticePageHeader;
